import { AwsRum, AwsRumConfig } from 'aws-rum-web';

const RUM_CONFIG: Record<string, { applicationId: string; identityPoolId: string }> = {
  beta: {
    applicationId: process.env.REACT_APP_RUM_APPLICATION_ID_BETA || '',
    identityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID_BETA || '',
  },
  prod: {
    applicationId: process.env.REACT_APP_RUM_APPLICATION_ID_PROD || '',
    identityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID_PROD || '',
  },
};

let awsRum: AwsRum | null = null;

export function initializeRum(): AwsRum | null {
  const env = process.env.REACT_APP_ENV || 'beta';
  const config = RUM_CONFIG[env];

  if (!config?.identityPoolId || !config?.applicationId) {
    console.warn('RUM: Identity Pool ID or Application ID not configured, skipping initialization');
    return null;
  }

  try {
    const rumConfig: AwsRumConfig = {
      identityPoolId: config.identityPoolId,
      telemetries: ['errors', 'http', 'performance'],
      allowCookies: true,
      enableXRay: true,
    };

    awsRum = new AwsRum(config.applicationId, '1.0.0', 'us-east-1', rumConfig);
    console.info('RUM: Initialized successfully');
    return awsRum;
  } catch (error) {
    console.error('RUM: Failed to initialize', error);
    return null;
  }
}

export function setRumUserMetadata(metadata: Record<string, string>): void {
  if (awsRum) {
    Object.entries(metadata).forEach(([key, value]) => {
      awsRum?.addSessionAttributes({ [key]: value });
    });
  }
}
